<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IitbBu/images/9781439658796.jpg?1684515803386" alt="This image is the cover for the book Milford, Then and Now"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Milford, Then and Now
      </h1>
      <p class="bookDescription body article font2">
        <p><b>On August 22, 1914, Milford, Connecticut, celebrated its 275th anniversary. An estimated crowd of 20,000 celebrated on the Milford Green alongside open-air horseless buggies.</b></p><br/><p>The celebration started at sunrise with a cannon salute and the sounding of church bells and factory whistles. Milford just recently celebrated its 375th anniversary.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael F. Clark
      </h2>
      
      <p class="authorDescription body article">Author Michael F. Clark was raised in and has spent most of his life in Milford. He believes that comparing the present to the past helps history become more real.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7c526484